import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import AddProductAndServices from './AddProductAndServices';
import { IProduct } from '../../../../Types/ProductTypes';
import { Spinner } from 'react-bootstrap';
import PopOver from '../../../../Components/PopOver/PopOver';
import { FaEye } from 'react-icons/fa';
import ProductDetailsWithModal from '../../../PublicProductAndServices/ProductDetailsWithModal';
import CommProfileHeader from '../CommProfileHeader';
import {
  useDeleteProductAndService,
  useGetProductAndServiceList,
} from '../../apiEndpoints/exhibitorApiEndpoints';
import CommonStatus from '../../../../Components/Common/CommonStatus';

const ProductAndServices = () => {
  const [toggle, setToggle] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const [viewSinData, setViewSinData] = useState<IProduct>();
  const { data, isLoading } = useGetProductAndServiceList();
  const { mutate } = useDeleteProductAndService();

  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add new Product & Service`}
        listHeadingTitle='Product & Service List'
        createBtnText='Add Item'
        toggle={toggle}
        setToggle={setToggle}
      />
      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <AddProductAndServices setToggle={setToggle} />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {isLoading ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className='text-center'>SL.</th>
                      <th className='text-center'>Name</th>
                      <th className='text-center'>Category</th>
                      <th className='text-center'>Price</th>
                      <th className='text-center'>Special Price</th>
                      <th className='text-center'>Status</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {data?.data && data?.data.length ? (
                        data?.data?.map((sProduct, index) => {
                          return (
                            <tr key={sProduct.fair_member_product_id}>
                              <td className='text-center'>{index + 1}</td>
                              <td className='text-center'>
                                {sProduct.fair_member_product_name}
                              </td>
                              <td className='text-center'>
                                {sProduct.fair_member_product_category}
                              </td>
                              <td className='text-center'>
                                {sProduct.fair_member_product_price}
                              </td>
                              <td className='text-center'>
                                {sProduct.fair_member_special_product_price}
                              </td>
                              <td className='text-center'>
                                <p
                                  className={
                                    sProduct.user_fair_member_product_status ===
                                    'approved'
                                      ? 'approved'
                                      : 'pending'
                                  }
                                >
                                  {CommonStatus(
                                    sProduct?.user_fair_member_product_status
                                  )}
                                </p>
                              </td>
                              <td className='d-flex gap-2 justify-content-center'>
                                <span
                                  className='pointer'
                                  onClick={() => {
                                    setShow(!show);
                                    setViewSinData(sProduct);
                                  }}
                                >
                                  <FaEye color='#00acee' size={20} />
                                </span>
                                <PopOver
                                  confirm={() => {
                                    mutate({
                                      id: sProduct.fair_member_product_id,
                                    });
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className='text-center'>
                          <td colSpan={7} className='fw-bold'>
                            No data found
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        )}
      </div>
      <ProductDetailsWithModal
        show={show}
        setShow={setShow}
        data={viewSinData}
      />
    </>
  );
};

export default ProductAndServices;
